import { render, staticRenderFns } from "./RecognitionUpdateForm.vue?vue&type=template&id=36895ddf"
import script from "./RecognitionUpdateForm.vue?vue&type=script&lang=js"
export * from "./RecognitionUpdateForm.vue?vue&type=script&lang=js"
import style0 from "./RecognitionUpdateForm.vue?vue&type=style&index=0&id=36895ddf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports